import axios from 'axios'
import { getCookieValue } from '../utils'

const registrationService = {
  candidateRegistration(context, jObject) {
    return new Promise((resolve, reject) => {
      axios
        .post('/registration', jObject)
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  acceptRegistration(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/registration/recruiter/accept/registration', payload, {
          transformRequest: [
            (data, headers) => {
              delete headers.common.Authorization
              return JSON.stringify(data)
            },
          ],
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  postRecruiter(context, jObject) {
    return new Promise((resolve, reject) => {
      axios
        .post('/registration/recruiter', jObject)
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  postNewactivationlink(context, email) {
    let data = {
      email: email,
    }
    return new Promise((resolve, reject) => {
      axios
        .post('/newactivationlink', data)
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getIndustryList(context, data) {
    console.log('LANGG', getCookieValue('lang'))
    let culture = getCookieValue('lang') === 'en' ? 'en' : 'gb'
    return new Promise((resolve, reject) => {
      axios
        .get('/industrylist/' + culture)
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  saveProspectInfo(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/visitors',
        data: payload,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
}
export default registrationService
